'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.fontPickerWidget = function (fontPickerModel) {
	if (!fontPickerModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const widget = this,
			fontSelector = widget.find('[data-mm-role~="font-selector"]'),
			fontComponentTemplate = widget.find('[data-mm-role=template]')
				.remove()
				.attr('data-mm-role', '');

		fontPickerModel.getTextFontFamilyKeys().forEach(fontFamilyKey => {
			const fontComponent = fontComponentTemplate.clone();
			fontComponent.find('a')
				.text(fontFamilyKey)
				.on('click', () => {
					fontPickerModel.fontPicked(fontFamilyKey);
				})
				.css({
					'font-family': fontPickerModel.getFontFamily(fontFamilyKey)
				});
			fontSelector.append(fontComponent);
		});
	});

};

